import { Images } from "../../../Images";
import GameOptions from "../../../model/options/GameOptions";
import Page from "../../framework/Page";
import View from "../../framework/View";

export default class GameOptionsToggle extends View {
    /**
     * @abstract
     * @param {string} parentId
     * @param {string} elementId 
     * @param {string} title
     * @param {GameOptions} gameOptions
     */
    constructor(parentId, elementId, title, gameOptions) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {string}
         */
        this.title = title;

        /**
         * @constant
         * @type {GameOptions}
         */
        this.gameOptions = gameOptions;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @type {boolean}
         */
        this.displayedEnabled = false;
    }

    /**
     * @override
     */
    initializeView() {
        // The upgrade view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('GameOptionsToggle.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.mainElement = Page.createElement('div', parent, id, 'upgrade-button-outer');

        const row1 = Page.createElement('div', this.mainElement, null, 'button-row-icon-text'); // 'pick-upgrade-button-row1'

        ////////////////////////////////////////////////////////
        // Row:
        // [icon] [title/description] [count/cost]
        ////////////////////////////////////////////////////////

        // <img src="images/miner_icon_51x48.png"/>
        const imgElement = Page.createElement('img', row1, null, 'pick-upgrade-icon');
        imgElement.src = Images.pick;

        // Title/Description container
        const titleDescriptionContainer = Page.createElement('div', row1, null, 'pick-upgrade-title-description-container');

        const titleElement = Page.createElement('div', titleDescriptionContainer, null, 'pick-upgrade-button-title-single-row');
        titleElement.innerHTML = this.title;

        //////////////////////////////////////
        // Button Click
        //////////////////////////////////////

        const thisRef = this;
        this.mainElement.onclick = function() {
            ////thisRef.gameOptions.crewBrainDebugEnabled = !thisRef.gameOptions.crewBrainDebugEnabled;
            thisRef.toggleEnabled();
        };

        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {

        const enabled = this.isEnabled();

        if (this.displayedEnabled === enabled) {
            return;
        }

        this.displayedEnabled = enabled;

        if (enabled) {
            this.mainElement.className = 'popup-toggle-button-outer-open';
        }
        else {
            this.mainElement.className = 'upgrade-button-outer';
        }
    }

    /**
     * @abstract
     * @param {boolean} enabled 
     */
    setEnabled(enabled) {
    }

    /**
     * @abstract
     * @returns {boolean}
     */
    isEnabled() {
        return false;        
    }

    /**
     * @abstract
     */
    toggleEnabled() {        
    }
}